const Generic = require("../GenericThemeFunctions")

module.exports = {
    defaultLanguage: 'en',
    scssVariables: './src/styles/douob',
    randomNickname:  () => { return Generic.RandomNickname() },
    defaultPassword: 'default'
}